export default [
  {
    path: "productos",
    name: "productos",
    component: () =>
      import(/* webpackChunkName: "catalogoProductos" */ "./productos.vue"),
  },
];
